import PropTypes from "prop-types";
import React from "react";
import {Translate} from "react-localize-redux";
import {Button} from "reactstrap";
import AWModal from "@aviwest/ui-kit/dist/js/components/modal";

const propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

const ResetConfigModal = (props) => {
  const { onCancel, onConfirm } = props;
  return (
    <AWModal id="resetconfig_modal"
             confirm={true}
             icon="restore"
             open={true}
             title={<Translate id="genericLabel.RESTORE_FACTORY_SETTINGS.text"/>}>
      <div className="confirm-text">
        <Translate id="genericLabel.CONFIRM_RESTORE_FACTORY_SETTINGS.text"/>
      </div>
      <div className="buttons">
        <Button id="resetconfig_modal_cancelButton"
                className="btn-cancel"
                size="lg"
                onClick={onCancel}>
          <Translate id="genericLabel.NO.text"/>
        </Button>
        <Button id="resetconfig_modal_confirmButton"
                color="primary"
                size="lg"
                onClick={onConfirm}>
          <Translate id="genericLabel.YES.text"/>
        </Button>
      </div>
    </AWModal>
  );
};

ResetConfigModal.propTypes = propTypes;

export default ResetConfigModal;